import styled from 'styled-components'

import { Link, useHistory } from 'react-router-dom'
import { panelNav } from './utils/panelNav'
import { useAuthContext } from './contexts/AuthContext'
import pulseAvatar from '../Assets/pulse_avatar.svg'
import bgRect from '../Assets/illustration_1.svg'
import pulseLogo from '../Assets/pulse_white_hor.svg'
import more from '../Assets/more.svg'
import bell from '../Assets/bell.svg'
import { Grid, Menu, MenuItem } from '@material-ui/core'
import CustomDialog from './partials/CustomDialog'
import { navDirections } from './utils/navDirections'
import { useState } from 'react'

function Home() {
    const [anchorEl, setAnchorEl] = useState(null)
    const [open, setOpen] = useState(false)
    const history = useHistory()

    const { userDetails, logout } = useAuthContext()

    const notificationStatus = true

    const isMenuOpen = Boolean(anchorEl)

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClickDialogOpen = () => {
        handleMenuClose()
        setOpen(true)
    }

    const goToProfilePage = () => {
        handleMenuClose()
        history.push(navDirections.MY_PROFILE)
    }

    const dialogSuccess = () => {
        logout()
    }

    return (
        <Container>
            <BgIllustration>
                <img src={bgRect} alt="background" />
            </BgIllustration>
            <ProfileContainer>
                <ProfileNav>
                    <ProfileLogo>
                        <img src={pulseLogo} alt="logo" />
                    </ProfileLogo>
                    <ProfileMoreInfo>
                        <ProfileButton onClick={handleProfileMenuOpen}>
                            <img src={more} alt="more" />
                        </ProfileButton>
                        <ProfileButton>
                            <img src={bell} alt="bell" />
                            {!!notificationStatus && <BellChip></BellChip>}
                        </ProfileButton>
                    </ProfileMoreInfo>
                </ProfileNav>

                <ProfileInfo>
                    <Grid container justify="center" alignItems="center">
                        <Grid item xs={5}>
                            <ProfileImage>
                                <img
                                    src={
                                        !!userDetails?.image
                                            ? userDetails?.image
                                            : pulseAvatar
                                    }
                                    alt="profile"
                                />
                            </ProfileImage>
                        </Grid>
                        <Grid item xs={7}>
                            <ProfileDetails>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <h3>{userDetails?.name}</h3>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <p>{`Batch`}</p>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <p>{`:`}</p>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <p>
                                            {!!userDetails?.batch?.batchName
                                                ? userDetails?.batch?.batchName
                                                : ''}
                                        </p>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <p>{`Roll No.`}</p>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <p>{`:`}</p>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <p>
                                            {!!userDetails?.rollNo
                                                ? userDetails?.rollNo
                                                : ''}
                                        </p>
                                    </Grid>
                                </Grid>
                            </ProfileDetails>
                        </Grid>
                    </Grid>
                </ProfileInfo>
            </ProfileContainer>
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={goToProfilePage}>Profile</MenuItem>
                <MenuItem onClick={handleClickDialogOpen}>Logout</MenuItem>
            </Menu>
            <CustomDialog
                title={'Are You Sure ?'}
                content={'You will be logged out from all sessions...'}
                cancelText={'Cancel'}
                forwardText={'Logout'}
                forwardFunc={dialogSuccess}
                open={open}
                setOpen={setOpen}
            />

            <Panel>
                <Grid
                    container
                    spacing={1}
                    justify="center"
                    alignItems="center"
                >
                    {panelNav.map((el, key) => (
                        <Grid item xs={4} key={key}>
                            <Link to={el.dest}>
                                <PanelButton>
                                    <ButtonImage>
                                        <img src={el.image} alt={el.text} />
                                    </ButtonImage>

                                    <ButtonText>{el.text}</ButtonText>
                                </PanelButton>
                            </Link>
                        </Grid>
                    ))}
                </Grid>
            </Panel>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    z-index: 0;
    padding-top: 20px;
    padding-bottom: 50px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
`

const BgIllustration = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -99;
    width: 75%;
    pointer-events: none;

    img {
        max-width: 600px;
        width: 100%;
    }
`
const ProfileContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
    padding: 20px;
    background: linear-gradient(
            314.55deg,
            rgba(255, 255, 255, 0.05) 2.86%,
            rgba(255, 255, 255, 0) 93.11%
        ),
        linear-gradient(
            131.63deg,
            rgba(41, 43, 92, 0.6) 9.65%,
            rgba(40, 43, 92, 0.58) 93.77%
        ),
        linear-gradient(
            105.27deg,
            rgba(255, 255, 255, 0.105) 2.25%,
            rgba(154, 154, 154, 0.035) 49.02%,
            rgba(201, 201, 201, 0.07) 60.55%,
            rgba(255, 255, 255, 0.042) 68.44%,
            rgba(129, 143, 161, 0.0424448) 84.06%,
            rgba(0, 28, 65, 0) 100%
        );
    box-shadow: 0px 0px 0px -1px rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(22px);
    border-radius: 15px;
`
const ProfileNav = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`
const ProfileLogo = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 120px;

    img {
        width: 100%;
    }
`
const ProfileMoreInfo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`
const ProfileButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 1.5rem;
    margin: 0 5px;
    cursor: pointer;
    position: relative;

    img {
        width: 100%;
    }
`
const BellChip = styled.div`
    background: radial-gradient(
        63.33% 63.33% at 14% 18.67%,
        #88fb93 0%,
        #2ddd60 100%
    );
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: -3px;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
`
const ProfileInfo = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-evenly;
    padding-top: 20px;
    padding-bottom: 10px;
    width: 100%;
`

const ProfileImage = styled.div`
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        width: 5.5rem;
        height: 5.5rem;
        border: 3px solid #fff;
        border-radius: 50%;
        object-fit: cover;
    }
`

const ProfileDetails = styled.div`
    color: #fff;

    h3 {
        font-size: 18px;
        margin: 5px 0;
        font-weight: 700;
    }
    p {
        font-size: 14px;
        font-weight: 500;
        margin: 3px 0;

        @media (min-width: 768px) {
            font-size: 16px;
        }
    }
`

const Panel = styled.div`
    max-width: 450px;
    margin: auto;
    margin-top: 30px;
    width: 100%;
    a {
        text-decoration: none;
    }
`

const PanelButton = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: auto;
    margin-bottom: 10px;
    height: 120px;
    width: 100%;
    max-width: 125px;
    background: linear-gradient(
            314.55deg,
            rgba(255, 255, 255, 0.05) 2.86%,
            rgba(255, 255, 255, 0) 93.11%
        ),
        linear-gradient(
            131.63deg,
            rgba(41, 43, 92, 0.6) 9.65%,
            rgba(40, 43, 92, 0.58) 93.77%
        ),
        linear-gradient(
            105.27deg,
            rgba(255, 255, 255, 0.105) 2.25%,
            rgba(154, 154, 154, 0.035) 49.02%,
            rgba(201, 201, 201, 0.07) 60.55%,
            rgba(255, 255, 255, 0.042) 68.44%,
            rgba(129, 143, 161, 0.0424448) 84.06%,
            rgba(0, 28, 65, 0) 100%
        );
    box-shadow: 0px 0px 0px -1px rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(22px);
    border-radius: 15px;
`

const ButtonImage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        height: 50px;
        width: 50px;
        object-fit: contain;
    }
`

const ButtonText = styled.p`
    color: #fff;
    font-size: 14px;
    padding: 5px;
    text-align: center;
    margin-top: 10px;
    font-weight: 500;
`

export default Home
